import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Subject, takeUntil } from 'rxjs';

import { AuthModuleConfigId, MwAuthService, MwUserService } from '../../auth';
import { UserProfileModel } from './../../auth/models/user-profile.model';
import { LocalStorageService } from './../../auth/services/local-storage.service';

@Component({
  selector: 'mw-dev-options',
  templateUrl: 'dev-options.component.html',
  styleUrls: ['./dev-options.component.scss'],
})
export class DevOptionsComponent implements OnInit, OnDestroy {
  AuthModuleConfigId = AuthModuleConfigId;
  authority: FormControl<AuthModuleConfigId | null>;
  useLocalCompanySelector: FormControl<boolean | null>;
  localhost = this.isLocalhost();
  legacyUrl = this.authService.isLegacyUrl();

  userProfile: UserProfileModel | null = null;
  claims: object | null = null;
  requireRefresh = false;

  private unsubscribeAll = new Subject<void>();

  constructor(
    private readonly authService: MwAuthService,
    private readonly userService: MwUserService
  ) {
    this.authority = new FormControl<AuthModuleConfigId>(
      this.authService.getConfigurationId(),
      { initialValueIsDefault: true }
    );

    this.useLocalCompanySelector = new FormControl<boolean>(
      LocalStorageService.getUseLocalCompanySelector()
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();

    if (this.requireRefresh) {
      window.location.reload();
    }
  }

  ngOnInit(): void {
    this.authority.valueChanges.subscribe((configId) => {
      this.authService.changeCurrentConfigurationId(
        configId ?? AuthModuleConfigId.MobileWorker
      );
      this.requireRefresh = this.authority.defaultValue !== configId;
    });

    this.useLocalCompanySelector.valueChanges.subscribe((useLocal) =>
      LocalStorageService.setUseLocalCompanySelector(useLocal || false)
    );

    this.userService.userProfile$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((userProfile) => (this.userProfile = userProfile));

    this.authService
      .getPayloadFromAccessToken()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((claims) => (this.claims = claims));
  }

  private isLocalhost(): boolean {
    const url = document.location.href;
    return url.includes('localhost') || url.includes('127.0.0.1');
  }
}
